import React from "react";
import imagePlug from "../../../src/zaslepka.jpg";

import styles from "../../pages/SingleVoting/SingleVoting.module.scss"

interface Props {
    title: string,
    artist: string,
    image: string,
    index: number
}


const DragOptionTable: React.FC<Props> = ({ artist, title, image, index }) => {
    return (
        <div className={styles.dragOptionWrapper}>
            <div className={styles.dragOrder}>
                {
                    index + 1 < 10 ? `0${index + 1}` : index + 1
                }
            </div>
            <div className={styles.dragImage}>
                <img src={!image ? imagePlug : image} alt="obrazek opcji" width={72} />
            </div>
            <div className={styles.dragRightSide}>
                <div className={styles.dragItem}>
                    {artist}
                </div>
                <div className={styles.dragItem}>
                    {title}
                </div>
            </div>
        </div>
    )
}

export default DragOptionTable;